import { Content } from '@prismicio/client';
import { Simplify } from '../../../../../../prismicio-types';

import styles from './getOfferAdvantages.module.scss';
import { BulletIcons } from '@/assets';

interface GetOfferAdvantagesProps {
  list:
    | Simplify<Content.GetOfferSliceDefaultPrimaryItemsItem>[]
    | Simplify<Content.GetOfferSliceWithProductsPrimaryItemsItem>[];
  isVisible: boolean;
}

export const GetOfferAdvantages = ({
  list,
  isVisible,
}: GetOfferAdvantagesProps) => {
  return (
    <ul className={`${styles.advantages}`}>
      {list.map((item, index) => (
        <li
          key={item.text}
          className={`${styles.item} ${isVisible ? styles.isVisible : ''} ${styles[`item-${index}`]}`}
        >
          <span className={styles.text}>{item.text}</span>
          <BulletIcons icon="white check" />
        </li>
      ))}
    </ul>
  );
};
